import { RoleModel } from '../../models/RoleModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const ADD_ROLE_TO_ROLE = '[Security] Role Add Role';

export class AddRoleToRoleAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = ADD_ROLE_TO_ROLE;

  constructor(public payload: { roleKey: string, role: RoleModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/AddRoleToRoleAction.ts